// // import { Html5QrcodeScanner } from "html5-qrcode";
// import { Html5Qrcode } from "html5-qrcode";

// import { useState, useEffect } from "react"; // import useRef
// import PropTypes from "prop-types";
// import { Grid, Icon, Snackbar, Alert, Box, Typography, Button, IconButton } from "@mui/material";
// import MDBox from "theme/components/MDBox";
// import MDButton from "theme/components/MDButton";
// import MDTypography from "theme/components/MDTypography";

// function BarcodeReaderField({ displayName, fieldRef, options }) {
//   const [fieldError, showFieldError] = useState(false);
//   const [errorMsg, setErrorMsg] = useState(null);

//   const [isScanning, setIsScanning] = useState(false);
//   const [scannedText, setScannedText] = useState(null);
//   const [scannerObj, setsCannerObj] = useState(null);

//   const config = { fps: 10, qrbox: { width: 250, height: 250 } };

//   function onScanSuccess(decodedText, decodedResult) {
//     // handle the scanned code as you like, for example:
//     // console.log(`Code matched = ${decodedText}`, decodedResult);
//     setScannedText(decodedText);
//     closeScanning();
//   }

//   function openScanner(camera) {
//     scannerObj.start(camera, config, onScanSuccess);
//     setIsScanning(true);
//   }

//   function closeScanning() {
//     if (scannerObj === null) {
//       console.log("Scanner object null");
//       return;
//     }

//     try {
//       scannerObj.stop();
//       setIsScanning(false);
//     } catch {}

//     // scannerObj
//     //   .stop()
//     //   .then((ignore) => {
//     //     setIsScanning(false);
//     //   })
//     //   .catch((err) => {
//     //     // Stop failed, handle it.
//     //     console.warn(`Code scan error = ${err}`);
//     //     setErrorMsg(err);
//     //     showFieldError(true);
//     //   });
//   }

//   function initScanning() {
//     Html5Qrcode.getCameras()
//       .then((devices) => {
//         if (devices && devices.length) {
//           var cameraId = devices[0].id;
//           let camera = { deviceId: { exact: cameraId } };
//           if (devices.length > 1) {
//             camera = { facingMode: { exact: "environment" } };
//           }
//           openScanner(camera);
//         }
//       })
//       .catch((err) => {
//         // handle err
//         // console.warn(`Code scan error = ${err}`);
//         setErrorMsg(`Code scan error = ${err}`);
//         showFieldError(true);
//       });
//   }

//   useEffect(() => {
//     setsCannerObj(new Html5Qrcode(`${fieldRef}_scanner`));
//   }, []);

//   return (
//     <Box>
//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         autoHideDuration={5000}
//         onClose={() => showFieldError(false)}
//         open={fieldError}
//       >
//         <Alert severity="error" sx={{ width: "100%" }}>
//           {errorMsg}
//         </Alert>
//       </Snackbar>
//       <Box sx={{ minWidth: 120, width: "100%" }}>
//         <Grid container spacing={3}>
//           <Grid item xs={6} md={6} lg={6}>
//             <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
//               {displayName}
//             </Typography>
//           </Grid>
//           <Grid mt={-1} item xs={6} md={6} lg={6}>
//             <Box align="right">
//               {!isScanning ? (
//                 <IconButton
//                   color="primary"
//                   variant="contained"
//                   iconOnly
//                   size="small"
//                   onClick={() => {
//                     initScanning();
//                   }}
//                   options={options}
//                 >
//                   <Icon>fit_screen</Icon>
//                 </IconButton>
//               ) : (
//                 <IconButton
//                   color="error"
//                   variant="contained"
//                   iconOnly
//                   size="small"
//                   onClick={() => {
//                     closeScanning();
//                   }}
//                   options={options}
//                 >
//                   <Icon>close</Icon>
//                 </IconButton>
//               )}
//             </Box>
//           </Grid>
//         </Grid>
//         <Box>
//           <div id={`${fieldRef}_scanner`}></div>
//         </Box>
//         <Box mt={isScanning ? 3 : 0}>
//           {scannedText ? (
//             <MDBox>
//               <MDTypography variant="h6" fontSize={14} fontWeight="regular">
//                 <b>Scan Result:</b>
//                 <br />
//                 {scannedText}
//               </MDTypography>
//               <MDBox>
//                 <MDButton
//                   size="small"
//                   onClick={() => {
//                     setScannedText(null);
//                   }}
//                 >
//                   [clear]
//                 </MDButton>
//               </MDBox>
//             </MDBox>
//           ) : (
//             <Typography variant="h6" fontSize={14}>
//               <small>Scan a bar code</small>
//             </Typography>
//           )}
//         </Box>
//       </Box>
//       <input id={`dff_${fieldRef}`} type="hidden" name={fieldRef} value={scannedText} />
//     </Box>
//   );
// }

// // Typechecking props of the Transaction
// BarcodeReaderField.propTypes = {
//   fieldRef: PropTypes.string.isRequired,
//   displayName: PropTypes.string.isRequired,
//   options: PropTypes.arrayOf(PropTypes.any),
// };

// BarcodeReaderField.defaultProps = {
//   options: null,
// };

// export default BarcodeReaderField;

import { Html5Qrcode } from "html5-qrcode";

import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Icon,
  Snackbar,
  Alert,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";

function BarcodeReaderField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [isScanning, setIsScanning] = useState(false);
  const [scannedText, setScannedText] = useState(null);
  const [scannerObj, setsCannerObj] = useState(null);

  const config = { fps: 10, qrbox: { width: 250, height: 250 } };

  function onScanSuccess(decodedText) {
    setScannedText(decodedText);
    closeScanning();
  }

  function openScanner(camera) {
    scannerObj.start(camera, config, onScanSuccess);
    setIsScanning(true);
  }

  function closeScanning() {
    if (scannerObj === null) return;

    try {
      scannerObj.stop();
      setIsScanning(false);
    } catch {}
  }

  function initScanning() {
    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          var cameraId = devices[0].id;
          let camera = { deviceId: { exact: cameraId } };
          if (devices.length > 1) {
            camera = { facingMode: "environment" };
          }
          openScanner(camera);
        }
      })
      .catch((err) => {
        setErrorMsg(`Code scan error = ${err}`);
        showFieldError(true);
      });
  }

  useEffect(() => {
    setsCannerObj(new Html5Qrcode(`${fieldRef}_scanner`));
  }, []);

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Box sx={{ minWidth: 120, width: "100%" }}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Box align="right">
              {!isScanning ? (
                <IconButton size="small" onClick={initScanning}>
                  <Icon>document_scanner</Icon>
                </IconButton>
              ) : (
                <IconButton size="small" color="error" onClick={closeScanning}>
                  <Icon>close</Icon>
                </IconButton>
              )}
            </Box>
          </Grid>
        </Grid>

        {/* CAPTURE BOX */}
        <Box
          sx={{
            border: "2px dashed #d2d6da",
            borderRadius: "12px",
            height: 220,
            position: "relative",
            overflow: "hidden",
            backgroundColor: "#f8f9fa",
            mt: 2,
          }}
        >
          {/* ALWAYS MOUNTED SCANNER (IMPORTANT) */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: isScanning ? "block" : "none",
            }}
          >
            <div
              id={`${fieldRef}_scanner`}
              style={{ width: "100%", height: "100%" }}
            />
          </Box>

          {/* EMPTY STATE */}
          {!isScanning && !scannedText && (
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box textAlign="center">
                <IconButton
                  color="primary"
                  onClick={initScanning}
                  sx={{
                    width: 64,
                    height: 64,
                    backgroundColor: "#e3f2fd",
                  }}
                >
                  <Icon fontSize="large">document_scanner</Icon>
                </IconButton>

                <Typography variant="caption" mt={1} display="block">
                  Tap to scan barcode
                </Typography>
              </Box>
            </Box>
          )}

          {/* RESULT */}
          {scannedText && !isScanning && (
            <>
              <Typography
                variant="body2"
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 2,
                  textAlign: "center",
                }}
              >
                {scannedText}
              </Typography>

              <IconButton
                onClick={() => setScannedText(null)}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  backgroundColor: "white",
                  border: "1px solid rgba(0,0,0,0.2)",
                  boxShadow: 2,
                }}
              >
                <Icon color="error">close</Icon>
              </IconButton>
            </>
          )}
        </Box>
      </Box>

      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={fieldRef}
        value={scannedText}
      />
    </Box>
  );
}

BarcodeReaderField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

BarcodeReaderField.defaultProps = {
  options: null,
};

export default BarcodeReaderField;
